import React, { useState } from 'react';
import { ChevronDownIcon, SquareIcon } from 'lucide-react';
import { states } from '../data/states';
import { services } from '../data/services';
export function Footer({
  onNavigate
}: {
  onNavigate?: (path: string) => void;
}) {
  const currentYear = new Date().getFullYear();
  const [openSection, setOpenSection] = useState<string | null>(null);
  const toggleSection = (section: string) => {
    setOpenSection(openSection === section ? null : section);
  };
  const popularStates = states.filter(s => ['CA', 'TX', 'FL', 'NY', 'PA', 'IL', 'OH', 'GA', 'NC', 'MI'].includes(s.abbreviation));
  const popularServices = services.slice(0, 10);
  const partnerCategories = [{
    category: 'Window Replacements',
    partners: [{
      name: 'Champion',
      path: '/champion/windows'
    }, {
      name: 'DaBella',
      path: '/dabella/windows'
    }, {
      name: 'K-Designers',
      path: '/k-designers/windows'
    }]
  }, {
    category: 'Sunrooms',
    partners: [{
      name: 'Champion',
      path: '/champion/sunrooms'
    }]
  }, {
    category: 'Siding',
    partners: [{
      name: 'Champion',
      path: '/champion/siding'
    }, {
      name: 'DaBella',
      path: '/dabella/siding'
    }, {
      name: 'K-Designers',
      path: '/k-designers/siding'
    }]
  }, {
    category: 'Other Exterior',
    partners: [{
      name: 'Champion',
      path: '/champion/other-exterior'
    }]
  }, {
    category: 'Roofing',
    partners: [{
      name: 'DaBella',
      path: '/dabella/roofing'
    }]
  }, {
    category: 'Gutters',
    partners: [{
      name: 'All American Gutter Protection',
      path: '/all-american-gutter'
    }]
  }, {
    category: 'Bathroom Remodels',
    partners: [{
      name: 'DaBella',
      path: '/dabella/baths'
    }, {
      name: 'Baths R Us',
      path: '/baths-r-us'
    }, {
      name: 'K-Designers',
      path: '/k-designers/bathroom'
    }]
  }, {
    category: 'Showers',
    partners: [{
      name: 'Kohler',
      path: '/kohler/showers'
    }]
  }, {
    category: 'Walk-In Baths',
    partners: [{
      name: 'Kohler',
      path: '/kohler/walk-in-baths'
    }]
  }, {
    category: 'Flooring',
    partners: [{
      name: 'Floor Coverings International',
      path: '/fci'
    }]
  }, {
    category: 'Doors',
    partners: [{
      name: 'K-Designers',
      path: '/k-designers/entry-doors'
    }]
  }, {
    category: 'HVAC',
    partners: []
  }, {
    category: 'Solar',
    partners: []
  }];
  return <footer className="bg-slate-950 pt-16 pb-8 border-t border-slate-900" data-id="element-1492">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-1493">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-16" data-id="element-1494">
          {/* Brand Column */}
          <div className="lg:col-span-1" data-id="element-1495">
            <a href="#" onClick={e => {
            e.preventDefault();
            onNavigate?.('/');
          }} className="text-2xl font-extrabold text-white tracking-tight mb-4 block" data-id="element-1496">
              FindService<span className="text-amber-500" data-id="element-1497">Quotes</span>
            </a>
            <p className="text-slate-400 leading-relaxed" data-id="element-1498">
              Connecting homeowners with trusted local professionals since 2019.
            </p>
          </div>

          {/* Services Column */}
          <div data-id="element-1499">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4" data-id="element-1500">
              Services
            </h3>
            <ul className="space-y-3" data-id="element-1501">
              {[{
              name: 'Walk-In Tubs',
              slug: 'walk-in-tubs'
            }, {
              name: 'Bathroom Remodel',
              slug: 'bathroom-remodel'
            }, {
              name: 'Roofing',
              slug: 'roofing'
            }, {
              name: 'Siding',
              slug: 'siding'
            }, {
              name: 'Window Replacement',
              slug: 'window-replacement'
            }, {
              name: 'Gutter Guards',
              slug: 'gutter-guards'
            }, {
              name: 'HVAC',
              slug: 'hvac'
            }, {
              name: 'Home Security',
              slug: 'home-security'
            }, {
              name: 'Flooring',
              slug: 'flooring'
            }].map(item => <li key={item.slug} data-id="element-1502">
                  <button onClick={() => onNavigate?.(`/near-me/${item.slug}`)} className="text-slate-400 hover:text-white transition-colors" data-id="element-1503">
                    {item.name}
                  </button>
                </li>)}
            </ul>
          </div>

          {/* Content Column — moved from nav */}
          <div data-id="element-1504">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4" data-id="element-1505">
              Content
            </h3>
            <div className="space-y-1" data-id="element-1506">
              {/* States Accordion */}
              <div data-id="element-1507">
                <button onClick={() => toggleSection('states')} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors group" data-id="element-1508">
                  <span className="font-medium" data-id="element-1509">States</span>
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openSection === 'states' ? 'rotate-180' : ''}`} data-id="element-1510" />
                </button>
                {openSection === 'states' && <div className="pl-3 pb-3 space-y-2 border-l border-slate-800 ml-1" data-id="element-1511">
                    {popularStates.map(state => <button key={state.abbreviation} onClick={() => onNavigate?.(`/states/${state.slug}`)} className="block text-sm text-slate-500 hover:text-amber-400 transition-colors" data-id="element-1512">
                        {state.name}
                      </button>)}
                    <button onClick={() => onNavigate?.('/states')} className="block text-sm font-semibold text-amber-500 hover:text-amber-400 transition-colors pt-1" data-id="element-1513">
                      View All States →
                    </button>
                  </div>}
              </div>

              {/* Cost Guides Accordion */}
              <div data-id="element-1514">
                <button onClick={() => toggleSection('costs')} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors group" data-id="element-1515">
                  <span className="font-medium" data-id="element-1516">Cost Guides</span>
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openSection === 'costs' ? 'rotate-180' : ''}`} data-id="element-1517" />
                </button>
                {openSection === 'costs' && <div className="pl-3 pb-3 space-y-2 border-l border-slate-800 ml-1" data-id="element-1518">
                    {popularServices.map(service => <button key={service.slug} onClick={() => onNavigate?.(`/costs/${service.slug}`)} className="block text-sm text-slate-500 hover:text-amber-400 transition-colors" data-id="element-1519">
                        {service.name}
                      </button>)}
                    <button onClick={() => onNavigate?.('/costs')} className="block text-sm font-semibold text-amber-500 hover:text-amber-400 transition-colors pt-1" data-id="element-1520">
                      View All Cost Guides →
                    </button>
                  </div>}
              </div>

              {/* Compare Services Accordion */}
              <div data-id="element-1521">
                <button onClick={() => toggleSection('compare')} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors group" data-id="element-1522">
                  <span className="font-medium" data-id="element-1523">Compare Services</span>
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openSection === 'compare' ? 'rotate-180' : ''}`} data-id="element-1524" />
                </button>
                {openSection === 'compare' && <div className="pl-3 pb-3 space-y-2 border-l border-slate-800 ml-1" data-id="element-1525">
                    {popularServices.map(service => <button key={service.slug} onClick={() => onNavigate?.(`/${service.slug}/best`)} className="block text-sm text-slate-500 hover:text-amber-400 transition-colors" data-id="element-1526">
                        Best {service.name}
                      </button>)}
                  </div>}
              </div>

              {/* Advertorials Accordion */}
              <div data-id="element-1527">
                <button onClick={() => toggleSection('advertorials')} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors group" data-id="element-1528">
                  <span className="font-medium" data-id="element-1529">Advertorials</span>
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openSection === 'advertorials' ? 'rotate-180' : ''}`} data-id="element-1530" />
                </button>
                {openSection === 'advertorials' && <div className="pl-3 pb-3 space-y-2 border-l border-slate-800 ml-1" data-id="element-1531">
                    {popularServices.map(service => <button key={service.slug} onClick={() => onNavigate?.(`/${service.slug}/articles/advertorial`)} className="block text-sm text-slate-500 hover:text-amber-400 transition-colors" data-id="element-1532">
                        {service.name}
                      </button>)}
                  </div>}
              </div>

              {/* Reviews Link */}
              <div data-id="element-1533">
                <button onClick={() => {
                onNavigate?.('/');
                setTimeout(() => document.getElementById('reviews')?.scrollIntoView({
                  behavior: 'smooth'
                }), 100);
              }} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors" data-id="element-1534">
                  <span className="font-medium" data-id="element-1535">Reviews</span>
                </button>
              </div>

              {/* Partners Accordion */}
              <div data-id="element-1536">
                <button onClick={() => toggleSection('partners')} className="w-full flex items-center justify-between py-2.5 text-slate-400 hover:text-white transition-colors group" data-id="element-1537">
                  <span className="font-medium" data-id="element-1538">Partners</span>
                  <ChevronDownIcon className={`w-4 h-4 transition-transform duration-200 ${openSection === 'partners' ? 'rotate-180' : ''}`} data-id="element-1539" />
                </button>
                {openSection === 'partners' && <div className="pl-3 pb-3 space-y-3 border-l border-slate-800 ml-1" data-id="element-1540">
                    {partnerCategories.map(cat => <div key={cat.category} data-id="element-1541">
                        <div className="text-[11px] font-bold text-slate-600 uppercase tracking-wider mb-1" data-id="element-1542">
                          {cat.category}
                        </div>
                        {cat.partners.length > 0 ? cat.partners.map(partner => <button key={partner.name} onClick={() => onNavigate?.(partner.path)} className="flex items-center gap-2 text-sm text-slate-500 hover:text-amber-400 transition-colors" data-id="element-1543">
                              <SquareIcon className="w-3 h-3 text-slate-600" data-id="element-1544" />
                              {partner.name}
                            </button>) : <span className="text-xs text-slate-600 italic" data-id="element-1545">
                            Coming soon
                          </span>}
                      </div>)}
                  </div>}
              </div>
            </div>
          </div>

          {/* Support Column */}
          <div data-id="element-1546">
            <h3 className="text-sm font-semibold text-white uppercase tracking-wider mb-4" data-id="element-1547">
              Support
            </h3>
            <ul className="space-y-3" data-id="element-1548">
              {['Help Center', 'Contact Us', 'Privacy Policy', 'Terms of Service'].map(item => <li key={item} data-id="element-1549">
                  <a href="#" className="text-slate-400 hover:text-white transition-colors" data-id="element-1550">
                    {item}
                  </a>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-slate-800 flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-1551">
          <p className="text-slate-500 text-sm text-center md:text-left" data-id="element-1552">
            &copy; {currentYear} FindServiceQuotes. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}